var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "empty" }, [
    _c("img", {
      attrs: {
        src: "https://img-fe.tengzhihh.com/image/49134cd0377920-146x146.png",
        alt: "",
        srcset: "",
      },
    }),
    _c("p", [_vm._v(_vm._s(_vm.label))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }